import { render, staticRenderFns } from "./HacizMasrafList.vue?vue&type=template&id=1cf5c07d"
import script from "./HacizMasrafList.vue?vue&type=script&lang=ts"
export * from "./HacizMasrafList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports